import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotStreams from './components/HotStreams';
import FeaturedAnchors from './components/FeaturedAnchors';
import CategoryNav from './components/CategoryNav';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { faqData } from '@/mocks/mogu-data';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotStreams />
        <FeaturedAnchors />
        <CategoryNav />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify([
            {
              '@context': 'https://schema.org',
              '@type': 'WebSite',
              name: '蘑菇tv',
              url: 'https://mogu.tv/',
              potentialAction: {
                '@type': 'SearchAction',
                target: 'https://mogu.tv/search?q={search_term_string}',
                'query-input': 'required name=search_term_string',
              },
            },
            {
              '@context': 'https://schema.org',
              '@type': 'WebPage',
              name: '蘑菇tv官方官网｜高清直播与视频平台',
              description: '蘑菇tv专注高清直播与短视频，海量娱乐、游戏、生活直播内容，随时随地畅享优质视频体验。',
              url: 'https://mogu.tv/',
              isPartOf: { '@type': 'WebSite', name: '蘑菇tv', url: 'https://mogu.tv/' },
            },
            {
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqData.map((faq) => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: faq.answer,
                },
              })),
            },
          ]),
        }}
      />
    </>
  );
}